import * as React from 'react'
import {FilterContainer} from '../../../View/Filtering/FilterContainer'
import * as PrismaRequestFilteringState from '../Model/PrismaRequestFilteringState'
import {PrismaRequestFilteringAction} from '../PrismaRequestFilteringActions'
import {PrismaRequestActiveFiltersView} from './PrismaRequestActiveFiltersView'
import {PrismaRequestFilterForm} from './PrismaRequestFilterForm'

interface Props {
    readonly state: PrismaRequestFilteringState.M
    readonly dispatch: (action: PrismaRequestFilteringAction) => void
}

export function PrismaRequestFilterContainer({state, dispatch}: Props) {
    return (
        <FilterContainer
            filterForm={
                <PrismaRequestFilterForm
                    state={state}
                    dispatch={dispatch}
                />
            }
            activeFiltersView={
                <PrismaRequestActiveFiltersView
                    state={state}
                    dispatch={dispatch}
                />
            }
            filterPopoverOpen={state.popoverOpen}
            onFilterPopoverToggle={
                open =>
                    dispatch({type: 'PopoverToggle', open})
            }
        />
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/View/PrismaRequestFilterContainer.tsx